import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "redux/ApiService/ApiService";
import Sessions from "utils/Sessions";

const getAllMobileUsers = createAsyncThunk("mobile-users-listing/api", async (param) => {
  const res = await ApiService.get(`user${param ? `?${param}` : ""}`, {
    // headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export const getAllPartners = createAsyncThunk("partner-users-listing/api", async (param) => {
  const res = await ApiService.get(`user/partner${param ? `?${param}` : ""}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export default getAllMobileUsers;
